import React, { useEffect, useRef, useState } from "react";
import { Badge, Card, Col, Collapse, Form, InputGroup, Modal, Offcanvas, Row, Spinner, Table } from "react-bootstrap";
import Moment from "react-moment";
import { LuSend } from "react-icons/lu";
import { FaRegCircleXmark } from "react-icons/fa6";
import { FaUser, FaUserShield } from "react-icons/fa";
import UseToggle from "../../../../Hooks/UseToggle";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studySettingControlServices } from "../../../../APIServices/studySettingControlServices";
import FieldCancelQuery from "./FieldCancelQuery";
import FieldReOpenQuery from "./FieldReOpenQuery";
import { isHTMLIdentifier } from "../../../../utils/universalFunction";

const FieldQueryHistory = ({
  Show,
  Hide,
  Title,
  tableRef,
  onMouseDown,
  queryButtonLoader,
  queryStatusButtonLoader,
  reOpenqueryButtonLoader,
  dataEntryQueryDiscussionLoader,
  reOpenQueryStudySubjectFormField,
  queryDiscussionStudySubjectFormField,
  generateManualQueryStatusStudySubjectFormField,
  getStudySubjectFormFieldQueryDiscussionDataEntry,
  setResponseMessage,
  responseMessage,
  queryData,
  setReasonMessage,
  reasonMessage,
  dataEntryQueryDiscussion,
}) => {
  const [openChatModule, setOpenChatModule] = useState("");
  const [querySubjectList, setQuerySubjectList] = useState([]);
  const [queryMessageList, setQueryMessageList] = useState([]);
  const [queryResponseList, setQueryResponseList] = useState([]);
  const [queryMessageType, setQueryMessageType] = useState("dynamic");
  const [queryResponseType, setQueryResponseType] = useState("dynamic");
  const [fieldTab, setFieldTab] = useState("");
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  const { toggle, setToggle, toggle1, setToggle1 } = UseToggle();
  const AppsRef = useRef(null);

  useEffect(() => {
    setOpenChatModule("")
  }, [Show]);

  const getQuerySubjectList = async () => {
    let data = await studySettingControlServices.getQuerySubjectList();
    setQuerySubjectList(data?.data);
  };

  const getActiveQueryMessageList = async (id) => {
    let data = await studySettingControlServices.getActiveQueryMessageList(id);
    setQueryMessageList(data.data);
  };

  const getActiveQueryResponseMessageList = async (id) => {
    let data = await studySettingControlServices.getActiveQueryResponseMessageList(id);
    setQueryResponseList(data.data);
  };

  useEffect(() => {
    if (Show && queryData) {
      setFieldTab(queryData?.fieldName);
      getStudySubjectFormFieldQueryDiscussionDataEntry(queryData?.siteId, queryData?.subjectId, queryData?.formId, queryData?.queryId)
      if (queryData?.subjectType === "dynamic") {
        getActiveQueryMessageList(queryData?.subject)
        getActiveQueryResponseMessageList(queryData?.subject)
      }
    }
  }, [Show, queryData]);

  useEffect(() => {
    getQuerySubjectList()
  }, []);

  const getStatusBadge = (status) => {
    const statusMap = {
      "open": "danger",
      "re-open": "danger",
      "answered": "primary",
      "responded": "primary",
      "close": "success",
      "cancel": "warning",
    };
    return statusMap[status] || "secondary";
  };

  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end" style={{ width: '700px' }}>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>
            {Title}
          </Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          <div className="px-3 pt-3" ref={AppsRef}>
            <Card className="mb-2 border bg-light">
              <Card.Body className="p-3">
                <Row className="mb-2">
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Site</small>
                    <div style={{ fontSize: "13px" }}>{queryData?.siteName}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Subject</small>
                    <div style={{ fontSize: "13px" }}>{queryData?.subjectName}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Event</small>
                    <div style={{ fontSize: "13px" }}>{queryData?.eventName} {queryData?.timePointLabel && `(${queryData?.timePointLabel})`}</div>
                  </Col>
                </Row>
                <Row className="mb-2">
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Form</small>
                    <div style={{ fontSize: "13px" }}>{queryData?.formName}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Version</small>
                    <div style={{ fontSize: "13px" }}>v{queryData?.formVersion}</div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Form Type</small>
                    <div className="text-capitalize" style={{ fontSize: "13px" }}>{queryData?.formType}</div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </div>
          <div className="px-3">
            <Card className="mb-2 border bg-light">
              <Card.Body className="p-3">
                <Row>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Field Label (Name)</small>
                    <div style={{ fontSize: "13px" }}>
                      {isHTMLIdentifier(queryData?.mainFieldLabel || "") ? (
                        <span
                          dangerouslySetInnerHTML={{
                            __html: queryData?.mainFieldLabel,
                          }}
                        />
                      ) : (
                        queryData?.mainFieldLabel
                      )} ({queryData?.mainFieldName})
                    </div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Sub Field Label (Name)</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.fieldLabel} ({queryData?.fieldName})
                    </div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Sub Field Value</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.fieldValue}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Category</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.subjectMessage}
                    </div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Status</small>
                    <div>
                      <Badge bg={queryData?.status === "open" ? "danger-subtle" : queryData?.status === "cancel" ? "warning-subtle" : "success-subtle"} className={`mb-1 ${queryData?.status === "open" ? "text-danger" : queryData?.status === "cancel" ? "text-warning" : "text-success"} text-capitalize CP`} style={{ fontSize: 9 }}>{queryData?.status}</Badge>
                    </div>
                  </Col>
                  <Col xs={4}>
                    <small className="text-muted fw-bold">Priority</small>
                    <div>
                      <Badge bg={(queryData?.priority === "critical" || queryData?.priority === "high") ? "danger-subtle" : queryData?.priority === "medium" ? "warning-subtle" : "success-subtle"} className={`mb-1 ${(queryData?.priority === "critical" || queryData?.priority === "high") ? "text-danger" : queryData?.priority === "medium" ? "text-warning" : "text-success"} text-capitalize CP`} style={{ fontSize: 9 }}>{queryData?.priority}</Badge>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            <Card className="mb-2 border bg-light">
              <Card.Body className="p-3">
                <Row>
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Raised by</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.generatedByName}
                    </div>
                  </Col>
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Assigned to</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.assignedToName}
                    </div>
                  </Col>
                </Row>
                <Row className="mt-2">
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Due Date</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.dueDate}
                    </div>
                  </Col>
                  <Col xs={6}>
                    <small className="text-muted fw-bold">Due Age</small>
                    <div style={{ fontSize: "13px" }}>
                      {queryData?.queryAge}
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
            {queryData?.queryType === "manual" ?
              <Card className="mb-2 border bg-light p-2">
                <Form.Group as={Col} md={12} className="mb-2">
                  <div className="hstack justify-content-between">
                    <div className="hstack gap-2">
                      <Form.Label className="fw-bold mb-1">
                        Response Message{" "}
                        <abbr title="Required" className="text-danger">
                          *
                        </abbr>
                      </Form.Label>
                      {!(queryStatusButtonLoader || queryData?.status !== "open") &&
                        <Badge onClick={() => setQueryResponseType((queryResponseType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic")} bg="primary" className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>{(queryResponseType === "dynamic" && queryMessageType === "dynamic") ? "custom" : "dynamic"}</Badge>
                      }
                    </div>
                    {(StudyMode?.startsWith("SDV") && queryData?.status === "open") &&
                      <div className="hstack gap-2">
                        <Badge onClick={() => { if (!queryStatusButtonLoader) generateManualQueryStatusStudySubjectFormField(queryData?.siteId, queryData?.subjectId, queryData?.schemaId, queryData?.eventId, queryData?.timePointUniqueId, queryData?.formId, queryData?.queryId, "close") }} bg={queryStatusButtonLoader ? "secondary" : "success"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                          {queryStatusButtonLoader === "close" ? <div className="hstack gap-2">
                            <Spinner style={{ height: 10, width: 10 }} size="sm" /> Closing...
                          </div>
                            : "Close Query"
                          }
                        </Badge>
                        <Badge onClick={() => { if (!queryStatusButtonLoader) setToggle() }} bg={queryStatusButtonLoader ? "secondary" : "danger"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                          {queryStatusButtonLoader === "cancel" ? <div className="hstack gap-2">
                            <Spinner style={{ height: 10, width: 10 }} size="sm" /> Cancelling...
                          </div>
                            : "Cancel Query"
                          }
                        </Badge>
                      </div>
                    }
                    {(StudyMode?.startsWith("SDV") && queryData?.status !== "open") &&
                      <Badge onClick={setToggle1} bg={reOpenqueryButtonLoader ? "secondary" : "danger"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                        {reOpenqueryButtonLoader ? <div className="hstack gap-2">
                          <Spinner style={{ height: 10, width: 10 }} size="sm" /> Re-Opening...
                        </div>
                          : "Re-Open Query"
                        }
                      </Badge>
                    }
                  </div>
                  {(queryMessageType === "dynamic" && queryResponseType === "dynamic") ?
                    <Form.Select
                      onChange={(e) => setResponseMessage(e.target.value)}
                      style={{ fontSize: 12 }}
                      className="br3"
                      disabled={queryStatusButtonLoader || queryData?.status !== "open"}
                      value={responseMessage}
                    >
                      <option value="">Select Message</option>
                      {queryResponseList?.map((item => (
                        <option value={item?.response}>
                          {item?.response}
                        </option>
                      )))}
                    </Form.Select>
                    :
                    <Form.Control
                      className="br3"
                      disabled={queryStatusButtonLoader || queryData?.status !== "open"}
                      onChange={(e) => setResponseMessage(e.target.value)}
                      value={responseMessage}
                      placeholder="Response Message"
                      as="textarea"
                    />
                  }
                </Form.Group>
                <div className="text-end">
                  <button
                    disabled={!responseMessage || queryButtonLoader || queryStatusButtonLoader || queryData?.status !== "open"}
                    onClick={() => queryDiscussionStudySubjectFormField(queryData?.siteId, queryData?.subjectId, queryData?.formId, queryData?.queryId)}
                    className="updateProfile"
                    style={{ fontSize: 12 }}
                  >
                    {queryButtonLoader ? <div className="hstack gap-2">
                      <Spinner size="sm" /> Sending...
                    </div>
                      : " Send Now"
                    }

                  </button>
                </div>
              </Card>
              :
              <div className="hstack justify-content-end">
                {(!StudyMode?.startsWith("SDV") && queryData?.status === "open") &&
                  <div className="hstack gap-2">
                    <Badge onClick={() => { if (!queryStatusButtonLoader) generateManualQueryStatusStudySubjectFormField(queryData?.siteId, queryData?.subjectId, queryData?.schemaId, queryData?.eventId, queryData?.timePointUniqueId, queryData?.formId, queryData?.queryId, "close") }} bg={queryStatusButtonLoader ? "secondary" : "success"} className="mb-1 text-capitalize CP rounded-1" style={{ fontSize: 9 }}>
                      {queryStatusButtonLoader === "close" ? <div className="hstack gap-2">
                        <Spinner style={{ height: 10, width: 10 }} size="sm" /> Closing...
                      </div>
                        : "Close Query"
                      }
                    </Badge>
                  </div>
                }
              </div>
            }
            <div>
              <h6 style={{ fontSize: 14 }} className="fw-bold mb-3">Query History & Audit</h6>
              {dataEntryQueryDiscussionLoader ?
                <div
                  className="hstack justify-content-center"
                  style={{ height: "calc(100vh - 580px)" }}
                >
                  <PageLoader />
                </div> :
                dataEntryQueryDiscussion.map((item, index) => (
                  <div key={index} className="mb-3">
                    <div className="d-flex align-items-start gap-3">
                      <div className="d-flex flex-column align-items-center">
                        <div style={{
                          width: "12px", height: "12px", borderRadius: "50%",
                          background: (item.status === "answered" || item.status === "responded") ? "#0d6efd" :
                            item.status === "close" ? "#198754" :
                              item.status === "cancel" ? "#d19916" :
                                (item.status === "open" || item.status === "re-open") ? "#ed0000" :
                                  "#787878",
                          marginTop: "4px"
                        }}>
                        </div>
                        {index < dataEntryQueryDiscussion?.length - 1 && (
                          <div style={{ width: "2px", height: "40px", background: "#dee2e6", margin: "4px 0" }}></div>
                        )}
                      </div>
                      <div style={{ flex: 1 }}>
                        <div className="hstack gap-2 flex-wrap">
                          <span className="fw-bold text-capitalize">{item.actionStatus === "cancel" ? "cancelled" : item.actionStatus === "close" ? "closed" : item?.actionStatus}</span>
                          <Badge bg={`${getStatusBadge(item.status)}-subtle`} className={`text-${getStatusBadge(item.status)} rounded-1 text-capitalize`} style={{ fontSize: 9 }}>
                            {item.status === "cancel" ? "cancelled" : item.status === "close" ? "closed" : item?.status}
                          </Badge>
                          <small className="text-muted ms-auto">{item.commentedByName}, {item.commentedDT}</small>
                        </div>
                        <Card className="mt-2 border bg-light p-2 w-100">
                          <div className="mt-1" style={{ fontSize: "13px", color: "#212529" }}>
                            {item.comment}
                          </div>
                        </Card>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </Offcanvas.Body>
      </Offcanvas>

      <FieldCancelQuery
        Show={!toggle}
        Hide={setToggle}
        queryStatusButtonLoader={queryStatusButtonLoader}
        generateManualQueryStatusStudySubjectFormField={generateManualQueryStatusStudySubjectFormField}
        Title="Cancel Query"
        setReasonMessage={setReasonMessage}
        reasonMessage={reasonMessage}
        queryData={queryData}
      />

      <FieldReOpenQuery
        Show={!toggle1}
        Hide={setToggle1}
        reOpenqueryButtonLoader={reOpenqueryButtonLoader}
        reOpenQueryStudySubjectFormField={reOpenQueryStudySubjectFormField}
        Title="Re-Open Query"
        setReasonMessage={setReasonMessage}
        reasonMessage={reasonMessage}
        queryData={queryData}
      />
    </>
  );
};

export default FieldQueryHistory;